import { accountEntityName } from '../../../../../backend/features/accounts/shared';
import { handleOrganizationMemberRoleAndStatus } from '../../../../../backend/features/organizations/bulk-actions/changeOrganizationMembersRoleAndStatus/handleOrganizationMemberRoleAndStatus';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { changeOrganizationMembersRoleAndStatusBulkActionType, } from '../../shared/bulk-actions/changeOrganizationMembersRoleAndStatusTypes';
export const changeOrganizationMembersRoleAndStatus = defineBulkAction({
    type: changeOrganizationMembersRoleAndStatusBulkActionType,
    onAuthBulkAction: (userContext, { createdBy, data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        const secureFilter = [...getAccountsViewFilterNew(userContext.userState), ...data.params.filter];
        if (!requireAnySystemPermission(userContext.userState, 'all-organizations-admin')) {
            secureFilter.push({ id: createdBy, op: '!=' });
        }
        return {
            secureFilter,
        };
    },
    onProcessBulkAction: (appContext, params) => {
        const accountStorage = appContext.storage(accountEntityName);
        const actionOwner = accountStorage.get(params.createdBy);
        forEachEntityRow(accountStorage, { filter: params.data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            handleOrganizationMemberRoleAndStatus({
                appContext,
                secureBulkActionParams: params,
                row,
                accountStorage,
                actionOwner,
                processedIndex: idx,
            });
        }, params.updateTotalCount);
    },
});
